export const playerCard = {
  PLAYER_CARD: '/player-card',
  PLAYER_CARD_ID: '/player-card/:playerId',
  SEARCH_PLAYERS: '/search/players',
}
